<div nxModalContent class="offer-leaflet-modal">
  <div id="offer-leaflet-print-section" class="offer-leaflet-section">
    <div nxLayout="grid" class="offer-leaflet">
      <div nxRow class="offer-leaflet-header">
        <div nxCol="9" alignSelf="end">
          <p nxCopytext="normal" class="nx-font-weight-semibold">{{ 'modals.offer-leaflet.subtitle' | translate }}</p>
        </div>
        <div nxCol="3" class="offer-leaflet-header__logo">
          <figure nxFigure>
            <img
                src="assets/allianz-logo.svg"
                alt="Allianz logo"
            />
        </figure>
        </div>
      </div>
      <div nxRow class="nx-margin-bottom-m">
        <div nxCol="12" class="offer-leaflet-title">
          <nx-icon name="product-plane" outline="true" size="s" class="nx-margin-right-2xs"></nx-icon>
          <h2 nxHeadline="subsection-large" class="nx-font-weight-bold">
            <p nxCopytext="normal" class="nx-font-weight-semibold">{{ 'modals.offer-leaflet.title' | translate }}</h2>
        </div>
      </div>
      <div nxRow class="nx-margin-bottom-xl">
        <div nxCol="6" class="">
          <div nxLayout="grid nogutters">
            <div nxRow class="offer-leaflet_cell-bg-blue">
              <div nxCol="6">
                <p nxCopytext="normal" class="nx-font-weight-semibold">{{ 'modals.offer-leaflet.calculation-date' | translate }}</p>
              </div>
              <div nxCol="6">
                <p nxCopytext="normal" class="nx-font-weight-semibold">{{calculationDate}} r.</p>
              </div>
            </div>
            <div *ngFor="let info of informationsAboutJourney" nxRow class="offer-leaflet_cell-info">
              <div nxCol="6">
                <p nxCopytext="normal" class="nx-font-weight-semibold">{{info.title}}</p>
              </div>
              <div nxCol="6">
                <p nxCopytext="normal" class="nx-font-weight-semibold">{{info.value}}</p>
              </div>
            </div>
          </div>
        </div>
        <div nxCol="6" class="">
          <div nxLayout="grid nogutters">
            <div nxRow class="offer-leaflet_cell-bg-blue">
              <div nxCol="12">
                <p nxCopytext="normal" class="nx-font-weight-semibold">{{ 'modals.offer-leaflet.agent-info.title' | translate }}</p>
              </div>
            </div>
            <div nxRow class="offer-leaflet_cell-info">
              <div nxCol="12">
                <p nxCopytext="normal" class="nx-font-weight-semibold">
                  {{agentInfo.agentFirstName}} {{agentInfo.agentLastName}}<span *ngIf="agentInfo.agentNumber">, {{ 'modals.offer-leaflet.agent-info.number' | translate }} {{agentInfo.agentNumber}}</span>
                </p>
              </div>
            </div>
            <div nxRow class="offer-leaflet_cell-info">
              <div nxCol="12">
                <p *ngIf="agentInfo.agentPhone" nxCopytext="normal" class="nx-font-weight-semibold">
                  {{ 'modals.offer-leaflet.agent-info.tel' | translate }}: <span *ngIf="agentInfo.agentPhone">{{agentInfo.agentPhone}}</span>
                </p>                
              </div>
            </div>
            <div nxRow class="offer-leaflet_cell-info">
              <div nxCol="12">
                <p nxCopytext="normal" class="nx-font-weight-semibold">
                  {{ 'modals.offer-leaflet.agent-info.email' | translate }}: <span *ngIf="agentInfo.agentMail">{{agentInfo.agentMail}}</span>
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div nxRow class="nx-margin-bottom-xl">
        <div nxCol="12">
          <div nxLayout="grid nogutters" class="offer-leaflet-package-table">
            <div nxRow rowAlignItems="center">
              <div nxCol="{{packageHeaderColumnsWidth}}" class="offer-leaflet-package-table__title">
                <nx-icon name="product-calculator" size="s" class="nx-margin-right-3xs"></nx-icon>
                <h3 nxHeadline="subsection-xsmall" class="nx-font-weight-bold">
                  {{ 'modals.offer-leaflet.package-compare.title' | translate }}
                </h3>
              </div>
              <div *ngIf="(packageTableProps$ | async)?.labelComfort" nxCol="{{packageColumnsWidth}}" class="offer-leaflet-package-table__header">
                <p nxCopytext="normal" class="nx-font-weight-bold">
                  {{ 'modals.offer-leaflet.package-compare.package-prefix' | translate }} {{(packageTableProps$ | async)?.labelComfort?.toUpperCase()}}
                </p>
              </div>
              <div *ngIf="(packageTableProps$ | async)?.labelPlus" nxCol="{{packageColumnsWidth}}" class="offer-leaflet-package-table__header">
                <p nxCopytext="normal" class="nx-font-weight-bold">
                  {{ 'modals.offer-leaflet.package-compare.package-prefix' | translate }} {{(packageTableProps$ | async)?.labelPlus?.toUpperCase()}}
                </p>
              </div>
              <div *ngIf="(packageTableProps$ | async)?.labelExtra" nxCol="{{packageColumnsWidth}}" class="offer-leaflet-package-table__header">
                <p nxCopytext="normal" class="nx-font-weight-bold">
                  {{ 'modals.offer-leaflet.package-compare.package-prefix' | translate }} {{(packageTableProps$ | async)?.labelExtra?.toUpperCase()}}
                </p>
              </div>
              <div *ngIf="(packageTableProps$ | async)?.labelMax" nxCol="{{packageColumnsWidth}}" class="offer-leaflet-package-table__header">
                <p nxCopytext="normal" class="nx-font-weight-bold">
                  {{ 'modals.offer-leaflet.package-compare.package-prefix' | translate }} {{(packageTableProps$ | async)?.labelMax?.toUpperCase()}}
                </p>
              </div>
            </div>
            <div nxRow>
              <div nxCol="{{packageHeaderColumnsWidth}}" class="offer-leaflet-package-table__cell offer-leaflet-package-table__cell-bg-blue"><div>&nbsp;</div></div>
              <div *ngFor="let package of numberOfPackages" nxCol="{{packageColumnsWidth}}" class="offer-leaflet-package-table__cell offer-leaflet-package-table__empty-cell"><div>&nbsp;</div></div>
            </div>
            <div nxRow *ngFor="let package of (packageTableProps$ | async)?.packageList">
              <div nxCol="{{packageHeaderColumnsWidth}}" class="offer-leaflet-package-table__row-title offer-leaflet-package-table__cell">
                <div>
                  <p nxCopytext="normal" class="nx-margin-left-xs">{{package.title}}</p>
                </div>
              </div>
              <div *ngIf="package.comfort" nxCol="{{packageColumnsWidth}}" class="offer-leaflet-package-table__cell">
                <div>
                  <nx-icon *ngIf="package.comfort !== true && package.comfort?.value" name="check-circle"></nx-icon>
                  <nx-icon *ngIf="package.comfort !== true && !package.comfort?.value" name="close"></nx-icon>
                  <p *ngIf="package.comfort !== true && package.comfort?.label" nxCopytext="small">{{package.comfort.label}}</p>
                </div>
              </div>
              <div *ngIf="package.plus" nxCol="{{packageColumnsWidth}}" class="offer-leaflet-package-table__cell">
                <div>
                  <nx-icon *ngIf="package.plus !== true && package.plus?.value" name="check-circle"></nx-icon>
                  <nx-icon *ngIf="package.plus !== true && !package.plus?.value" name="close"></nx-icon>
                  <p *ngIf="package.plus !== true && package.plus?.label" nxCopytext="small">{{package.plus.label}}</p>
                </div>
              </div>
              <div *ngIf="package.extra" nxCol="{{packageColumnsWidth}}" class="offer-leaflet-package-table__cell">
                <div>
                  <nx-icon *ngIf="package.extra !== true && package.extra?.value" name="check-circle"></nx-icon>
                  <nx-icon *ngIf="package.extra !== true && !package.extra?.value" name="close"></nx-icon>
                  <p *ngIf="package.extra !== true && package.extra?.label" nxCopytext="small">{{package.extra.label}}</p>
                </div>
              </div>
              <div *ngIf="package.max" nxCol="{{packageColumnsWidth}}" class="offer-leaflet-package-table__cell">
                <div>
                  <nx-icon *ngIf="package.max !== true && package.max?.value" name="check-circle"></nx-icon>
                  <nx-icon *ngIf="package.max !== true && !package.max?.value" name="close"></nx-icon>
                  <p *ngIf="package.max !== true && package.max?.label" nxCopytext="small">{{package.max.label}}</p>
                </div>
              </div>
            </div>
            
          </div>
        </div>
      </div>

      <div nxRow class="nx-margin-bottom-l">
        <div nxCol="12">
          <div nxLayout="grid nogutters" class="offer-leaflet-package-table">
            <div nxRow>
              <div nxCol="{{packageHeaderColumnsWidth}}" class="offer-leaflet-package-table__cell offer-leaflet-package-table__cell-bg-blue">
                <div>
                  <p nxCopytext="normal" class="nx-font-weight-semibold u-text-center offer-leaflet-package-table__cell-white-text">{{ 'modals.offer-leaflet.package-compare.addons-title' | translate }}</p>
                </div>
              </div>
              <div *ngFor="let package of numberOfPackages" nxCol="{{packageColumnsWidth}}" class="offer-leaflet-package-table__cell offer-leaflet-package-table__empty-cell"><div>&nbsp;</div></div>
            </div>
            <div nxRow *ngFor="let addon of (packageTableProps$ | async)?.addonsList">
              <div nxCol="{{packageHeaderColumnsWidth}}" class="offer-leaflet-package-table__row-title offer-leaflet-package-table__cell">
                <div>
                  <p nxCopytext="normal" class="nx-margin-left-xs">{{addon.title}}</p>
                </div>
              </div>
              <div *ngIf="addon.comfort" nxCol="{{packageColumnsWidth}}" class="offer-leaflet-package-table__cell">
                <div>
                  <nx-icon *ngIf="addon.comfort !== true" name="plus-circle" [ngClass]="{'offer-leaflet-package-table__addon-icon-checked': addon.comfort.value}" class="offer-leaflet-package-table__addon-icon"></nx-icon>
                  <p *ngIf="addon.comfort !== true && addon.comfort?.label" nxCopytext="small">{{addon.comfort.label}}</p>
                </div>
              </div>
              <div *ngIf="addon.plus" nxCol="{{packageColumnsWidth}}" class="offer-leaflet-package-table__cell">
                <div>
                  <nx-icon *ngIf="addon.plus !== true" name="plus-circle" [ngClass]="{'offer-leaflet-package-table__addon-icon-checked': addon.plus.value}" class="offer-leaflet-package-table__addon-icon"></nx-icon>
                  <p *ngIf="addon.plus !== true && addon.plus?.label" nxCopytext="small">{{addon.plus.label}}</p>
                </div>
              </div>
              <div *ngIf="addon.extra" nxCol="{{packageColumnsWidth}}" class="offer-leaflet-package-table__cell">
                <div>
                  <nx-icon *ngIf="addon.extra !== true" name="plus-circle" [ngClass]="{'offer-leaflet-package-table__addon-icon-checked': addon.extra.value}" class="offer-leaflet-package-table__addon-icon"></nx-icon>
                  <p *ngIf="addon.extra !== true && addon.extra?.label" nxCopytext="small">{{addon.extra.label}}</p>
                </div>
              </div>
              <div *ngIf="addon.max" nxCol="{{packageColumnsWidth}}" class="offer-leaflet-package-table__cell">
                <div>
                  <nx-icon *ngIf="addon.max !== true" name="plus-circle" [ngClass]="{'offer-leaflet-package-table__addon-icon-checked': addon.max.value}" class="offer-leaflet-package-table__addon-icon"></nx-icon>
                  <p *ngIf="addon.max !== true && addon.max?.label" nxCopytext="small">{{addon.max.label}}</p>
                </div>
              </div>
            </div>
            <div nxRow>
              <div nxCol="{{packageHeaderColumnsWidth}}" class="offer-leaflet-package-table__cell offer-leaflet-package-table__cell-bg-blue">
                <div>
                  <p nxCopytext="normal" class="nx-font-weight-semibold u-text-center offer-leaflet-package-table__cell-white-text">{{ 'modals.offer-leaflet.package-compare.summary' | translate }}</p>
                </div>
              </div>
              <div *ngIf="(packageTableProps$ | async)?.packageListSummary?.comfort" nxCol="{{packageColumnsWidth}}" class="offer-leaflet-package-table__cell offer-leaflet-package-table__summary-cell">
                <div>
                  <p nxCopytext="normal" class="nx-font-weight-semibold">{{(packageTableProps$ | async)?.packageListSummary?.comfort?.label}}</p>
                </div>
              </div>
              <div *ngIf="(packageTableProps$ | async)?.packageListSummary?.plus" nxCol="{{packageColumnsWidth}}" class="offer-leaflet-package-table__cell offer-leaflet-package-table__summary-cell">
                <div>
                  <p nxCopytext="normal" class="nx-font-weight-semibold">{{(packageTableProps$ | async)?.packageListSummary?.plus?.label}}</p>
                </div>
              </div>
              <div *ngIf="(packageTableProps$ | async)?.packageListSummary?.extra" nxCol="{{packageColumnsWidth}}" class="offer-leaflet-package-table__cell offer-leaflet-package-table__summary-cell">
                <div>
                  <p nxCopytext="normal" class="nx-font-weight-semibold">{{(packageTableProps$ | async)?.packageListSummary?.extra?.label}}</p>
                </div>
              </div>
              <div *ngIf="(packageTableProps$ | async)?.packageListSummary?.max" nxCol="{{packageColumnsWidth}}" class="offer-leaflet-package-table__cell offer-leaflet-package-table__summary-cell">
                <div>
                  <p nxCopytext="normal" class="nx-font-weight-semibold">{{(packageTableProps$ | async)?.packageListSummary?.max?.label}}</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div nxRow>
        <div nxCol="12">
          <div nxLayout="grid nogutters">
            <div nxRow class="offer-leaflet__section-with-border nx-margin-bottom-2xs">
              <div nxCol="3" class="nx-margin-top-2xs">
                <p nxCopytext="normal" class="nx-font-weight-bold">{{ 'modals.offer-leaflet.conditions.title' | translate }}</p>
              </div>
              <div nxCol="9" class="nx-margin-top-2xs">
                <ol nxList="xsmall">
                  <li class="nx-margin-bottom-2xs">{{ 'modals.offer-leaflet.conditions.list.element1' | translate }}</li>
                  <li class="nx-margin-bottom-2xs">{{ 'modals.offer-leaflet.conditions.list.element2' | translate }}</li>
                </ol>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div nxRow class="nx-margin-bottom-m">
        <div nxCol="12">
          <p nxCopytext="small" class="nx-font-weight-bold">{{ 'modals.offer-leaflet.other.title' | translate }}</p>
        </div>
      </div>

      <div nxRow>
        <div nxCol="6">
          <div nxLayout="grid nogutters">
            <div nxRow class="offer-leaflet__contact-box">
              <div nxCol="6">
                <p nxCopytext="normal" class="nx-font-weight-bold">{{ 'modals.offer-leaflet.other.contact-title' | translate }}</p>
                <p nxCopytext="normal" class="nx-font-weight-bold">
                  <nx-icon name="phone"></nx-icon>
                  {{ 'modals.offer-leaflet.other.phone-contact' | translate }}
                </p>
              </div>
              <div nxCol="6" alignSelf="end" class="offer-leaflet__contact-box-link">
                <p nxCopytext="normal" class="nx-font-weight-bold">
                  <a href="https://allianz.pl/" nxPlainButton>www.allianz.pl</a>
                </p>
              </div>
            </div>
          </div>
        </div>
        <div nxCol="6">
          <p nxCopytext="xsmall" class="offer-leaflet__clause">
            {{ 'modals.offer-leaflet.other.clause' | translate }}
          </p>
        </div>
      </div>
    </div>
  </div>
</div>

<div nxModalActions class="offer-leaflet__modal-actions modal-actions">
  <app-modal-close></app-modal-close>
  <button
    nxButton
    bodyClass="offer-leaflet-print"
    [useExistingCss]="true"
    printSectionId="offer-leaflet-print-section"
    ngxPrint
  >
    {{ 'modals.offer-leaflet.print-btn' | translate }}
  </button>
</div>
